import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { DatePicker, Icon, InputWithIcon, SelectMenu } from '@livable/saas-react-components';
import { TextField, MenuItem } from '@mui/material';
import React, { useState } from 'react';
import notificationsData from './data';
import NotificationBlock from './NotificationBlock';
import useStyles from './styles';
export default function NotificationsTab() {
  const classes = useStyles();
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    fromDate = _useState2[0],
    setFromDate = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    toDate = _useState4[0],
    setToDate = _useState4[1];
  const _useState5 = useState('all'),
    _useState6 = _slicedToArray(_useState5, 2),
    type = _useState6[0],
    setType = _useState6[1];
  const handleTypeChange = event => {
    if (event.target.value) setType(event.target.value);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.searchBar
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.searchField
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "charges-search",
    label: "Search",
    variant: "outlined",
    fullWidth: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.filterSelector
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    id: "type-selector",
    value: type,
    label: "Type",
    labelId: "type-selector-label",
    onChange: handleTypeChange
  }, /*#__PURE__*/React.createElement(MenuItem, {
    value: "all"
  }, "All types"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "charge"
  }, "Charge"), /*#__PURE__*/React.createElement(MenuItem, {
    value: "credit"
  }, "Credit"))), /*#__PURE__*/React.createElement("div", {
    className: classes.chargesRangeDatePicker
  }, /*#__PURE__*/React.createElement(DatePicker, {
    value: fromDate,
    onChange: date => setFromDate(date),
    format: "MM/dd/yy",
    label: "From"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.chargesRangeDatePicker
  }, /*#__PURE__*/React.createElement(DatePicker, {
    value: toDate,
    onChange: date => setToDate(date),
    format: "MM/dd/yy",
    label: "To"
  }))), notificationsData.map(notificationsBlock => /*#__PURE__*/React.createElement(NotificationBlock, {
    data: notificationsBlock,
    key: notificationsBlock.date
  })));
}